var Marionette = require('backbone.marionette');

var PersonModel = require('../../models/person-model');
var MedProfileModel = require('../../models/med-profile-model');
var PermissionModel = require('../../models/permission-model');

var DocumentsCollection = require('../../collections/documents-collection');
var PermissionsCollection = require('../../collections/permissions-collection');

var MergeFromPersonDemographicsView = require('./merge-from-person-demographics-view');
var MergeToPersonDemographicsView = require('./merge-to-person-demographics-view');
var MergeFromPersonContactsView = require('./merge-from-person-contacts-view');
var MergeToPersonContactsView = require('./merge-to-person-contacts-view');
var MergeFromPersonDiseasesView = require('./merge-from-person-diseases-view');
var MergeToPersonDiseasesView = require('./merge-to-person-diseases-view');
var MergeFromPersonMedicationsView = require('./merge-from-person-medications-view');
var MergeToPersonMedicationsView = require('./merge-to-person-medications-view');
var MergePersonDocumentsView = require('./merge-person-documents-view');
var MergePersonPermissionsView = require('./merge-person-permissions-view');

var YesNoConfirmationModal = require('../common/yes-no-confirmation-modal');

var CommonUtils = require('../../utils/common-utils.js');
var Radio = require('backbone.radio');

var notificationsChannel = Radio.channel('notifications');


var MergePersonsDetailView = Marionette.View.extend({
    template: require('../../templates/persons/merge-persons-detail-view.html'),

    regions: {
        mergeFromPersonDemographicsRegion: '#merge-from-person-demographics-data',
        mergeFromPersonContactsRegion: '#merge-from-person-contacts-data',
        mergeFromPersonDiseasesRegion: '#merge-from-person-diseases-data',
        mergeFromPersonMedicationsRegion: '#merge-from-person-medications-data',
        mergeFromPersonDocumentsRegion: '#merge-from-person-documents-data',
        mergeFromPersonPermissionsRegion: '#merge-from-person-permissions-data',
        mergeToPersonDemographicsRegion: '#merge-to-person-demographics-data',
        mergeToPersonContactsRegion: '#merge-to-person-contacts-data',
        mergeToPersonDiseasesRegion: '#merge-to-person-diseases-data',
        mergeToPersonMedicationsRegion: '#merge-to-person-medications-data',
        mergeToPersonDocumentsRegion: '#merge-to-person-documents-data',
        mergeToPersonPermissionsRegion: '#merge-to-person-permissions-data',

        cancelConfirmationRegion: '#cancel-confirmation-modal',
        saveConfirmationRegion: '#save-confirmation-modal',
        saveAndDeleteConfirmationRegion: '#save-and-delete-confirmation-modal'
    },

    ui: {
        back: '#back',
        save: '#save',
        saveAndDelete: '#save-and-delete',
        cancel: '#cancel',

        cancelConfirmationModal: '#cancel-confirmation-modal',
        saveConfirmationModal: '#save-confirmation-modal',
        saveAndDeleteConfirmationModal: '#save-and-delete-confirmation-modal'
    },

    events: {
        'click @ui.back': 'onBack',
        'click @ui.cancel': 'onCancel',
        'click @ui.save': 'onSave',
        'click @ui.saveAndDelete': 'onSaveAndDelete'
    },

    childViewEvents: {
        'action:confirmed': 'saveConfirmed',

        'merge:person:demographics': 'onMergePersonDemographics',
        'restore:person:demographics': 'onRestorePersonDemographics',
        'edit:person:demographics': 'onEditPersonDemographics',
        'merge:person:contacts:row': 'onMergeRowPersonContacts',
        'remove:person:contacts:row': 'onRemoveRowPersonContacts',
        'merge:person:diseases:row': 'onMergeRowPersonDiseases',
        'remove:person:diseases:row': 'onRemoveRowPersonDiseases',
        'merge:person:medications:row': 'onMergeRowPersonMedications',
        'remove:person:medications:row': 'onRemoveRowPersonMedications',
        'merge:person:documents:row': 'onMergeRowPersonDocuments',
        'remove:person:documents:row': 'onRemoveRowPersonDocuments',
        'merge:person:permissions:row': 'onMergeRowPersonPermissions',
        'remove:person:permissions:row': 'onRemoveRowPersonPermissions'
    },

    templateContext: function () {
        var that = this;
        return {
            withBack: that.getOption('withBack')
        }
    },

    initialize: function (options) {

        this.utils = new CommonUtils();

        this.mergeFromPersonModel = new PersonModel(options.mergeFromPerson);

        var mergeFromMedProfileNotSorted = options.mergeFromPersonMedProfile;
        var mergeFromMedProfileSorted = this.sortMedProfile(mergeFromMedProfileNotSorted);
        this.mergeFromPersonMedProfileModel = new MedProfileModel(mergeFromMedProfileSorted);

        this.mergeToPersonModel = new PersonModel(options.mergeToPerson);

        var mergeToMedProfileNotSorted = options.mergeToPersonMedProfile;
        var mergeToMedProfileSorted = this.sortMedProfile(mergeToMedProfileNotSorted);
        this.mergeToPersonMedProfileModel = new MedProfileModel(mergeToMedProfileSorted);

        this.mergeToPersonModelOriginal = new PersonModel(this.utils.deepClone(options.mergeToPerson));
        this.mergeToPersonMedProfileModelOriginal = new MedProfileModel(this.utils.deepClone(mergeToMedProfileSorted));

        this.mergeFromPersonDocumentsModel = new Backbone.Model();
        this.mergeFromPersonDocumentsModelOriginal = new Backbone.Model();
        this.mergeToPersonDocumentsModel = new Backbone.Model();
        this.mergeToPersonDocumentsModelOriginal = new Backbone.Model();

        this.mergeFromPersonPermissionsModel = new Backbone.Model();
        this.mergeFromPersonPermissionsModelOriginal = new Backbone.Model();
        this.mergeToPersonPermissionsModel = new Backbone.Model();
        this.mergeToPersonPermissionsModelOriginal = new Backbone.Model();
    },


    onRender: function () {
        var that = this;

        that.checkModelsChanges();

        that.renderMergeFromPersonDemographicsRegion();
        that.renderMergeToPersonDemographicsRegion();

        that.renderMergeFromPersonContactsRegion();
        that.renderMergeToPersonContactsRegion();

        that.renderMergeFromPersonDiseasesRegion();
        that.renderMergeToPersonDiseasesRegion();

        that.renderMergeFromPersonMedicationsRegion();
        that.renderMergeToPersonMedicationsRegion();

        that.renderMergeFromPersonDocumentsRegion();
        that.renderMergeToPersonDocumentsRegion();

        that.renderMergeToPersonPermissionsRegion();
        window.setTimeout(function () {
            that.renderMergeFromPersonPermissionsRegion();
        }, 600);

        this.cancelConfirmationModal = new YesNoConfirmationModal({
            title: 'Cancel confirmation',
            message: 'You are going to cancel all made works. Are you sure?'
        });
        this.showChildView('cancelConfirmationRegion', this.cancelConfirmationModal);

        this.saveConfirmationModal = new YesNoConfirmationModal({
            title: 'Save confirmation',
            message: 'You are going to save merged person. Are you sure?'
        });
        this.showChildView('saveConfirmationRegion', this.saveConfirmationModal);

        this.saveAndDeleteConfirmationModal = new YesNoConfirmationModal({
            title: 'Save and delete confirmation',
            message: 'You are going to save merged person and remove "from merge" person. Are you sure?'
        });
        this.showChildView('saveAndDeleteConfirmationRegion', this.saveAndDeleteConfirmationModal);
    },

    renderMergeFromPersonDemographicsRegion: function () {
        var that = this;
        that.showChildView('mergeFromPersonDemographicsRegion', new MergeFromPersonDemographicsView({
            model: that.mergeFromPersonModel,
            mergeFromPersonId: that.getMergeFromPersonId(),
            mergeFromPersonName: that.getMergeFromPersonName(),
            isBeingMerged: function (modelAttrName) {
                return that.mergeToPersonModel.get('object')[modelAttrName] == that.mergeFromPersonModel.get('object')[modelAttrName];
            }
        }));
    },

    renderMergeToPersonDemographicsRegion: function () {
        var that = this;
        that.showChildView('mergeToPersonDemographicsRegion', new MergeToPersonDemographicsView({
            model: that.mergeToPersonModel,
            mergeToPersonId: that.getMergeToPersonId(),
            mergeToPersonName: that.getMergeToPersonName(),
            isBeingMerged: function (modelAttrName) {
                return that.mergeToPersonModel.get('object')[modelAttrName] != that.mergeToPersonModelOriginal.get('object')[modelAttrName];
            }
        }));
    },

    renderMergeFromPersonContactsRegion: function () {
        var that = this;
        that.showChildView('mergeFromPersonContactsRegion', new MergeFromPersonContactsView({
            model: that.mergeFromPersonModel,
            mergeFromPersonId: that.getMergeFromPersonId(),
            mergeFromPersonName: that.getMergeFromPersonName(),
            isBeingMerged: function (contact) {
                return _.filter(that.mergeToPersonModel.get('object').contacts || [], function (item) {
                        return contact.data == item.data && contact.type == item.type && contact.preferred == item.preferred;
                    }).length > 0;
            }
        }));
    },

    renderMergeToPersonContactsRegion: function () {
        this.showChildView('mergeToPersonContactsRegion', new MergeToPersonContactsView({
            model: this.mergeToPersonModel,
            modelCopyAsOriginal: this.mergeToPersonModelOriginal,
            mergeToPersonId: this.getMergeToPersonId(),
            mergeToPersonName: this.getMergeToPersonName()
        }));
    },

    renderMergeFromPersonDiseasesRegion: function () {
        var that = this;
        that.showChildView('mergeFromPersonDiseasesRegion', new MergeFromPersonDiseasesView({
            model: that.mergeFromPersonMedProfileModel,
            mergeFromPersonId: that.getMergeFromPersonId(),
            mergeFromPersonName: that.getMergeFromPersonName(),
            isBeingMerged: function (disease) {
                return (that.mergeToPersonMedProfileModel.get('object').diseases || []).filter(function (d) {
                        return _.isEqual(d, disease);
                    }).length > 0;
            }
        }));
    },

    renderMergeToPersonDiseasesRegion: function () {
        this.showChildView('mergeToPersonDiseasesRegion', new MergeToPersonDiseasesView({
            model: this.mergeToPersonMedProfileModel,
            modelCopyAsOriginal: this.mergeToPersonMedProfileModelOriginal,
            mergeToPersonId: this.getMergeToPersonId(),
            mergeToPersonName: this.getMergeToPersonName()
        }));
    },

    renderMergeFromPersonMedicationsRegion: function () {
        var that = this;
        that.showChildView('mergeFromPersonMedicationsRegion', new MergeFromPersonMedicationsView({
            model: that.mergeFromPersonMedProfileModel,
            mergeFromPersonId: that.getMergeFromPersonId(),
            mergeFromPersonName: that.getMergeFromPersonName(),
            isBeingMerged: function (medication) {
                return (that.mergeToPersonMedProfileModel.get('object').medications || []).filter(function (m) {
                        return _.isEqual(m, medication);
                    }).length > 0;
            }
        }));
    },

    renderMergeToPersonMedicationsRegion: function () {
        this.showChildView('mergeToPersonMedicationsRegion', new MergeToPersonMedicationsView({
            model: this.mergeToPersonMedProfileModel,
            modelCopyAsOriginal: this.mergeToPersonMedProfileModelOriginal,
            mergeToPersonId: this.getMergeToPersonId(),
            mergeToPersonName: this.getMergeToPersonName()
        }));
    },

    renderMergeFromPersonDocumentsRegion: function () {
        this.renderPersonDocuments('from');
    },

    renderMergeToPersonDocumentsRegion: function () {
        this.renderPersonDocuments('to');
    },

    renderPersonDocuments: function (mode) {
        var that = this;
        var personDocuments = new DocumentsCollection([], {
            params: [
                {key: 'sortby', value: 'createdTime'},
                {key: 'sortdir', value: 'DESC'},
                {
                    key: 'object_patientId',
                    value: mode == 'from' ? that.getMergeFromPersonId() : that.getMergeToPersonId()
                }
            ]
        });
        personDocuments.fetch({
            success: function () {
                var documents = personDocuments.models.map(function (model) {
                    return {
                        id: model.attributes.id,
                        name: model.attributes.name,
                        createdTime: model.attributes.createdTime
                    };
                });

                if (mode == 'from') {
                    that.mergeFromPersonDocumentsModel = new Backbone.Model({documents: documents});
                    that.mergeFromPersonDocumentsModelOriginal = new Backbone.Model({documents: that.utils.deepClone(documents)});
                    that.renderMergeFromPersonDocuments();
                } else {
                    that.mergeToPersonDocumentsModel = new Backbone.Model({documents: documents});
                    that.mergeToPersonDocumentsModelOriginal = new Backbone.Model({documents: that.utils.deepClone(documents)});
                    that.renderMergeToPersonDocuments();
                }
            },
            error: function (e) {
                console.log(e);
            }
        });
    },

    renderMergeFromPersonDocuments: function () {
        this.showChildView('mergeFromPersonDocumentsRegion', new MergePersonDocumentsView({
            mode: 'from',
            mergeFromPersonDocumentsModel: this.mergeFromPersonDocumentsModel,
            personId: this.getMergeFromPersonId(),
            personName: this.getMergeFromPersonName()
        }));
    },

    renderMergeToPersonDocuments: function () {
        this.showChildView('mergeToPersonDocumentsRegion', new MergePersonDocumentsView({
            mode: 'to',
            mergeToPersonDocumentsModel: this.mergeToPersonDocumentsModel,
            mergeToPersonDocumentsModelOriginal: this.mergeToPersonDocumentsModelOriginal,
            personId: this.getMergeToPersonId(),
            personName: this.getMergeToPersonName()
        }));
    },

    renderMergeFromPersonPermissionsRegion: function () {
        this.renderPersonPermissions('from');
    },

    renderMergeToPersonPermissionsRegion: function () {
        this.renderPersonPermissions('to');
    },

    renderPersonPermissions: function (mode) {
        var that = this;
        var personPermissions = new PermissionsCollection([], {
            params: [{
                key: 'permittedObjectId',
                value: mode == 'from' ? that.getMergeFromPersonId() : that.getMergeToPersonId()
            }]
        });
        personPermissions.fetch({
            success: function () {
                var perms = personPermissions.models.filter(function (model) {
                    return model.attributes.permittedObjectId != model.attributes.ownerId;
                }).map(function (model) {
                    return {
                        id: model.attributes.id,
                        permittedOrgPersonToRead: model.attributes.permittedOrgPersonToRead,
                        permittedOrgToRead: model.attributes.permittedOrgToRead,
                        permittedObjectId: model.attributes.permittedObjectId,
                        ownerId: model.attributes.ownerId,
                        organizationId: model.attributes.organizationId,
                        grantedToReviewer: model.attributes.grantedToReviewer,
                        canRead: model.attributes.canRead,
                        canReadAll: model.attributes.canReadAll,
                        canReadFor: model.attributes.canReadFor,
                        canWrite: model.attributes.canWrite,
                        canWriteAll: model.attributes.canWriteAll,
                        canWriteFor: model.attributes.canWriteFor,
                        canSign: model.attributes.canSign,
                        canSignAll: model.attributes.canSignAll,
                        canUploadFor: model.attributes.canUploadFor,
                        canDelete: model.attributes.canDelete,
                        canChangeReviewer: model.attributes.canChangeReviewer,
                        owner: model.attributes.owner,
                        organization: model.attributes.organization
                    };
                });

                if (mode == 'from') {
                    that.mergeFromPersonPermissionsModel = new Backbone.Model({perms: that.sortPermissions(perms)});
                    that.mergeFromPersonPermissionsModelOriginal = new Backbone.Model({perms: that.utils.deepClone(that.sortPermissions(perms))});
                    that.renderMergeFromPersonPermissions();
                } else {
                    that.mergeToPersonPermissionsModel = new Backbone.Model({perms: that.sortPermissions(perms)});
                    that.mergeToPersonPermissionsModelOriginal = new Backbone.Model({perms: that.utils.deepClone(that.sortPermissions(perms))});
                    that.renderMergeToPersonPermissions();
                }
            },
            error: function (e) {
                console.log(e);
            }
        });
    },

    renderMergeFromPersonPermissions: function () {
        var that = this;
        that.showChildView('mergeFromPersonPermissionsRegion', new MergePersonPermissionsView({
            mode: 'from',
            mergeFromPersonPermissionsModel: that.mergeFromPersonPermissionsModel,
            personId: that.getMergeFromPersonId(),
            personName: that.getMergeFromPersonName(),
            isBeingMerged: function (permission) {
                return that.mergedPermissionsCount(that.mergeToPersonPermissionsModel.get('perms'), permission).length > 0;
            }
        }));
    },

    renderMergeToPersonPermissions: function () {
        this.showChildView('mergeToPersonPermissionsRegion', new MergePersonPermissionsView({
            mode: 'to',
            mergeToPersonPermissionsModel: this.mergeToPersonPermissionsModel,
            mergeToPersonPermissionsModelOriginal: this.mergeToPersonPermissionsModelOriginal,
            personId: this.getMergeToPersonId(),
            personName: this.getMergeToPersonName(),
            mergedPermissionsCount: this.mergedPermissionsCount
        }));
    },

    onMergePersonDemographics: function (modelAttrName) {
        this.mergeToPersonModel.get('object')[modelAttrName] = this.mergeFromPersonModel.get('object')[modelAttrName];
        this.getChildView('mergeToPersonDemographicsRegion').render();
        this.getChildView('mergeFromPersonDemographicsRegion').render();
        this.checkModelsChanges();
    },

    onRestorePersonDemographics: function (modelAttrName) {
        this.mergeToPersonModel.get('object')[modelAttrName] = this.mergeToPersonModelOriginal.get('object')[modelAttrName];
        this.getChildView('mergeToPersonDemographicsRegion').render();
        this.getChildView('mergeFromPersonDemographicsRegion').render();
        this.checkModelsChanges();
    },

    onEditPersonDemographics: function (data) {
        this.mergeToPersonModel.get('object')[data.fieldName] = data.value;
        this.getChildView('mergeToPersonDemographicsRegion').render();
        this.getChildView('mergeFromPersonDemographicsRegion').render();
        this.checkModelsChanges();
    },

    onMergeRowPersonContacts: function (data) {
        var contacts = this.mergeToPersonModel.get('object').contacts || [];
        var contact = data.contact;

        if (typeof (_.findWhere(contacts, {
                type: contact.type,
                data: contact.data,
                preferred: contact.preferred
            })) != 'undefined')
            return;

        contacts.splice(data.insertedIndex, 0, contact);

        this.mergeToPersonModel.get('object').contacts = contacts;
        this.getChildView('mergeFromPersonContactsRegion').render();
        this.getChildView('mergeToPersonContactsRegion').render();
        this.checkModelsChanges();
    },

    onRemoveRowPersonContacts: function (removedContact) {
        this.mergeToPersonModel.get('object').contacts = _.filter(this.mergeToPersonModel.get('object').contacts,
            function (contact) {
                return !_.isEqual(contact, removedContact);
            });
        this.getChildView('mergeFromPersonContactsRegion').render();
        this.getChildView('mergeToPersonContactsRegion').render();
        this.checkModelsChanges();
    },

    onMergeRowPersonDiseases: function (data) {
        var diseases = this.mergeToPersonMedProfileModel.get('object').diseases || [];
        var disease = data.disease;

        if (diseases.filter(function (d) {
                return _.isEqual(d, disease);
            }).length > 0)
            return;

        diseases.push(disease);

        this.mergeToPersonMedProfileModel.get('object').diseases = _.chain(diseases)
            .sortBy(function (item) {
                return item.uuid;
            })
            .value();
        this.getChildView('mergeFromPersonDiseasesRegion').render();
        this.getChildView('mergeToPersonDiseasesRegion').render();
        this.checkModelsChanges();
    },

    onRemoveRowPersonDiseases: function (removedDisease) {
        this.mergeToPersonMedProfileModel.get('object').diseases = _.chain(this.mergeToPersonMedProfileModel.get('object').diseases)
            .filter(function (disease) {
                return !_.isEqual(disease, removedDisease);
            })
            .sortBy(function (item) {
                return item.uuid;
            })
            .value();

        this.getChildView('mergeFromPersonDiseasesRegion').render();
        this.getChildView('mergeToPersonDiseasesRegion').render();
        this.checkModelsChanges();
    },

    onMergeRowPersonMedications: function (data) {
        var medications = this.mergeToPersonMedProfileModel.get('object').medications || [];
        var medication = data.medication;

        if (medications.filter(function (d) {
                return _.isEqual(d, medication);
            }).length > 0)
            return;

        medications.push(medication);

        this.mergeToPersonMedProfileModel.get('object').medications = _.chain(medications)
            .sortBy(function (item) {
                return item.groupUuid + item.medicationUuid;
            })
            .value();
        this.getChildView('mergeFromPersonMedicationsRegion').render();
        this.getChildView('mergeToPersonMedicationsRegion').render();
        this.checkModelsChanges();
    },

    onRemoveRowPersonMedications: function (removedMedication) {
        this.mergeToPersonMedProfileModel.get('object').medications = _.chain(this.mergeToPersonMedProfileModel.get('object').medications)
            .filter(function (medication) {
                return !_.isEqual(medication, removedMedication);
            })
            .sortBy(function (item) {
                return item.groupUuid + item.medicationUuid;
            })
            .value();

        this.getChildView('mergeFromPersonMedicationsRegion').render();
        this.getChildView('mergeToPersonMedicationsRegion').render();
        this.checkModelsChanges();
    },

    onMergeRowPersonDocuments: function (data) {
        this.mergeOrRemoveDocument(data.document, data.insertedIndex, this.mergeFromPersonDocumentsModel, this.mergeToPersonDocumentsModel, data.onlyRemove);
    },

    onRemoveRowPersonDocuments: function (data) {
        this.mergeOrRemoveDocument(data.document, data.insertedIndex, this.mergeToPersonDocumentsModel, this.mergeFromPersonDocumentsModel, data.onlyRemove);
    },

    mergeOrRemoveDocument: function (document, index, sourceModel, targetModel, onlyRemove) {

        sourceModel.set('documents', _.filter(sourceModel.get('documents') || [],
            function (d) {
                return !_.isEqual(document, d);
            })
        );

        if (!onlyRemove) {
            var documents = targetModel.get('documents') || [];
            documents.splice(index, 0, document);
            targetModel.set('documents', documents);
        }

        this.getChildView('mergeFromPersonDocumentsRegion').render();
        this.getChildView('mergeToPersonDocumentsRegion').render();
        this.checkModelsChanges();
    },

    onMergeRowPersonPermissions: function (data) {
        var permissions = this.mergeToPersonPermissionsModel.get('perms') || [];
        var permission = data.permission;

        if (this.mergedPermissionsCount(permissions, permission).length > 0)
            return;

        permissions.push(permission);

        this.mergeToPersonPermissionsModel.set('perms', this.sortPermissions(permissions));
        this.getChildView('mergeFromPersonPermissionsRegion').render();
        this.getChildView('mergeToPersonPermissionsRegion').render();
        this.checkModelsChanges();
    },

    onRemoveRowPersonPermissions: function (data) {
        var removedPermission = data.permission;
        var permissions = _.filter(this.mergeToPersonPermissionsModel.get('perms'),
            function (permission) {
                return permission.id != removedPermission.id;
            });
        this.mergeToPersonPermissionsModel.set('perms', this.sortPermissions(permissions));
        this.getChildView('mergeFromPersonPermissionsRegion').render();
        this.getChildView('mergeToPersonPermissionsRegion').render();
        this.checkModelsChanges();
    },

    checkModelsChanges: function () {
        this.triggerMethod('have:models:changes');
    },

    onBack: function () {
        this.triggerMethod('back:to:select');
    },

    onCancel: function () {
        var that = this;
        that.callback = function () {
            that.mergeToPersonModel = new PersonModel(that.utils.deepClone(that.mergeToPersonModelOriginal.attributes));
            that.renderMergeFromPersonDemographicsRegion();
            that.renderMergeFromPersonContactsRegion();
            that.renderMergeToPersonDemographicsRegion();
            that.renderMergeToPersonContactsRegion();

            that.mergeToPersonMedProfileModel = new MedProfileModel(that.utils.deepClone(that.mergeToPersonMedProfileModelOriginal.attributes));
            that.renderMergeFromPersonDiseasesRegion();
            that.renderMergeFromPersonMedicationsRegion();
            that.renderMergeToPersonDiseasesRegion();
            that.renderMergeToPersonMedicationsRegion();

            that.mergeFromPersonDocumentsModel = new Backbone.Model({documents: that.utils.deepClone(that.mergeFromPersonDocumentsModelOriginal.get('documents'))});
            that.mergeToPersonDocumentsModel = new Backbone.Model({documents: that.utils.deepClone(that.mergeToPersonDocumentsModelOriginal.get('documents'))});
            that.renderMergeToPersonDocuments();
            that.renderMergeFromPersonDocuments();

            that.mergeFromPersonPermissionsModel = new Backbone.Model({perms: that.utils.deepClone(that.mergeFromPersonPermissionsModelOriginal.get('perms'))});
            that.mergeToPersonPermissionsModel = new Backbone.Model({perms: that.utils.deepClone(that.mergeToPersonPermissionsModelOriginal.get('perms'))});
            that.renderMergeToPersonPermissions();
            that.renderMergeFromPersonPermissions();

            that.checkModelsChanges();
        }
        that.cancelConfirmationModal.show();
    },

    onSave: function () {
        this.commitMerge(false);
    },

    onSaveAndDelete: function () {
        this.commitMerge(true);
    },

    commitRemove: function () {
        var that = this;
        that.mergeFromPersonMedProfileModel.destroy();
        that.mergeFromPersonModel.destroy();

        Backbone.history.navigate('/person/' + that.mergeToPersonModel.get('id'), {trigger: true});
    },

    commitMerge: function (doDelete) {
        var that = this;

        that.callback = function () {

            if (!_.isEqual(that.mergeToPersonModel.attributes, that.mergeToPersonModelOriginal.attributes)
                && !_.isEqual(that.mergeToPersonMedProfileModel.attributes, that.mergeToPersonMedProfileModelOriginal.attributes)) {

                that.mergeToPersonMedProfileModel.save(that.mergeToPersonMedProfileModel.toJSON(), {
                    success: function () {
                        that.mergeToPersonModel.save(that.mergeToPersonModel.toJSON(), {
                            success: function () {
                                that.saveDocumentPatientsChanges();
                                that.savePermissionChanges();
                                if (doDelete) {
                                    that.commitRemove();
                                } else {
                                    that.mergeToPersonModelOriginal = new PersonModel(that.utils.deepClone(that.mergeToPersonModel.attributes));
                                    that.renderMergeToPersonDemographicsRegion();
                                    that.renderMergeToPersonContactsRegion();
                                    that.mergeToPersonMedProfileModelOriginal = new MedProfileModel(that.utils.deepClone(that.mergeToPersonMedProfileModel.attributes));
                                    that.renderMergeToPersonDiseasesRegion();
                                    that.renderMergeToPersonMedicationsRegion();
                                    that.syncMergePatientsDocuments();
                                    that.syncMergePatientsPermissions();
                                    that.checkModelsChanges();
                                }

                            },
                            error: function (model, xhr, options) {
                                notificationsChannel.request('show:notification', xhr.responseText);
                                //rollback medprofile
                                that.mergeToPersonMedProfileModelOriginal.save();
                            }
                        });
                    },
                    error: function (model, xhr, options) {
                        notificationsChannel.request('show:notification', xhr.responseText);
                    }
                });

            } else if (!_.isEqual(that.mergeToPersonModel.attributes, that.mergeToPersonModelOriginal.attributes)) {

                that.mergeToPersonModel.save(that.mergeToPersonModel.toJSON(), {
                    success: function () {
                        that.saveDocumentPatientsChanges();
                        that.savePermissionChanges();
                        if (doDelete) {
                            that.commitRemove();
                        } else {
                            that.mergeToPersonModelOriginal = new PersonModel(that.utils.deepClone(that.mergeToPersonModel.attributes));
                            that.renderMergeToPersonDemographicsRegion();
                            that.renderMergeToPersonContactsRegion();
                            that.syncMergePatientsDocuments();
                            that.syncMergePatientsPermissions();
                            that.checkModelsChanges();
                        }
                    },
                    error: function (model, xhr, options) {
                        notificationsChannel.request('show:notification', xhr.responseText);
                    }
                });

            } else if (!_.isEqual(that.mergeToPersonMedProfileModel.attributes, that.mergeToPersonMedProfileModelOriginal.attributes)) {

                that.mergeToPersonMedProfileModel.save(that.mergeToPersonMedProfileModel.toJSON(), {
                    success: function () {
                        that.saveDocumentPatientsChanges();
                        that.savePermissionChanges();
                        if (doDelete) {
                            that.commitRemove();
                        } else {
                            that.mergeToPersonMedProfileModelOriginal = new MedProfileModel(that.utils.deepClone(that.mergeToPersonMedProfileModel.attributes));
                            that.renderMergeToPersonDiseasesRegion();
                            that.renderMergeToPersonMedicationsRegion();
                            that.syncMergePatientsDocuments();
                            that.syncMergePatientsPermissions();
                            that.checkModelsChanges();
                        }
                    },
                    error: function (model, xhr, options) {
                        notificationsChannel.request('show:notification', xhr.responseText);
                    }
                });

            } else {
                that.saveDocumentPatientsChanges();
                that.savePermissionChanges();
                if (doDelete) {
                    that.commitRemove();
                }
                else {
                    that.syncMergePatientsDocuments();
                    that.syncMergePatientsPermissions();
                    that.checkModelsChanges();
                }
            }

        }

        if (doDelete)
            that.saveAndDeleteConfirmationModal.show();
        else
            that.saveConfirmationModal.show();
    },

    saveDocumentPatientsChanges: function () {
        var that = this;
        if (_.isEqual(that.mergeToPersonDocumentsModel.attributes, that.mergeToPersonDocumentsModelOriginal.attributes))
            return;

        var originals = that.mergeToPersonDocumentsModelOriginal.get('documents');
        that.mergeToPersonDocumentsModel.get('documents').forEach(function (document) {

            var exists = _.findWhere(originals, {id: document.id});
            if (!exists) {
                $.ajax({
                    type: "POST",
                    url: '/api/document/' + document.id + '/patient/' + that.getMergeToPersonId(),
                    statusCode: {
                        200: function (response) {
                        }
                    },
                    error: function (e) {
                        console.log(e);
                    }
                });
            }

        });

        originals.forEach(function (document) {

            var exists = _.findWhere(that.mergeToPersonDocumentsModel.get('documents'), {id: document.id});
            if (!exists) {
                $.ajax({
                    type: "DELETE",
                    url: '/api/document/' + document.id + '/patient/' + that.getMergeToPersonId(),
                    statusCode: {
                        200: function (response) {
                        }
                    },
                    error: function (e) {
                        console.log(e);
                    }
                });
            }

        });

    },

    syncMergePatientsDocuments: function () {
        if (_.isEqual(this.mergeToPersonDocumentsModel.attributes, this.mergeToPersonDocumentsModelOriginal.attributes))
            return;
        this.mergeFromPersonDocumentsModelOriginal = new Backbone.Model({documents: this.utils.deepClone(this.mergeFromPersonDocumentsModel.get('documents'))});
        this.mergeToPersonDocumentsModelOriginal = new Backbone.Model({documents: this.utils.deepClone(this.mergeToPersonDocumentsModel.get('documents'))});
        this.renderMergeToPersonDocuments();
    },

    savePermissionChanges: function () {
        var that = this;
        if (!that.hasPermissionsChanges())
            return;

        var originals = that.mergeToPersonPermissionsModelOriginal.get('perms');
        that.mergeToPersonPermissionsModel.get('perms').forEach(function (permission) {

            if (that.mergedPermissionsCount(originals, permission).length == 0) {
                permission = _.omit(permission, 'id');
                permission = _.omit(permission, 'owner');
                permission = _.omit(permission, 'organization');
                permission.permittedObjectId = that.getMergeToPersonId();
                var permissionsModel = new PermissionModel(permission);
                permissionsModel.save(permissionsModel.toJSON());
            }
        });

        originals.forEach(function (permission) {

            if (that.mergedPermissionsCount(that.mergeToPersonPermissionsModel.get('perms'), permission).length == 0) {
                var permissionsModel = new PermissionModel(permission);
                permissionsModel.destroy();
            }
        });
    },

    syncMergePatientsPermissions: function () {
        if (!this.hasPermissionsChanges())
            return;
        this.mergeFromPersonPermissionsModelOriginal = new Backbone.Model({perms: this.utils.deepClone(this.mergeFromPersonPermissionsModel.get('perms'))});
        this.mergeToPersonPermissionsModelOriginal = new Backbone.Model({perms: this.utils.deepClone(this.mergeToPersonPermissionsModel.get('perms'))});
        this.renderMergeToPersonPermissions();
    },

    onHaveModelsChanges: function () {
        var that = this;

        if (_.isEqual(that.mergeToPersonModel.attributes, that.mergeToPersonModelOriginal.attributes)
            && _.isEqual(that.mergeToPersonMedProfileModel.attributes, that.mergeToPersonMedProfileModelOriginal.attributes)
            && _.isEqual(that.mergeToPersonDocumentsModel.attributes, that.mergeToPersonDocumentsModelOriginal.attributes)
            && !that.hasPermissionsChanges()) {
            that.disableButtons();
        } else {
            that.enableButtons();
        }
    },

    saveConfirmed: function (data) {
        if (data.result == true) {
            this.callback();
        }
        else {
            this.cancelConfirmationModal.hide();
            this.saveConfirmationModal.hide();
            this.saveAndDeleteConfirmationModal.hide();
        }
    },

    enableButtons: function () {
        this.ui.save.removeAttr('disabled');
        this.ui.saveAndDelete.removeAttr('disabled');
        this.ui.cancel.removeAttr('disabled');
    },

    disableButtons: function () {
        this.ui.save.attr('disabled', true);
        this.ui.saveAndDelete.attr('disabled', true);
        this.ui.cancel.attr('disabled', true);
    },

    getMergeFromPersonId: function () {
        return this.mergeFromPersonModel.get('id');
    },

    getMergeFromPersonName: function () {
        return this.mergeFromPersonModel.get('name');
    },

    getMergeToPersonId: function () {
        return this.mergeToPersonModel.get('id');
    },

    getMergeToPersonName: function () {
        return this.mergeToPersonModel.get('name');
    },

    sortMedProfile: function (medProfile) {
        medProfile.object.medications = _.sortBy(medProfile.object.medications, function (item) {
            return item.groupUuid + item.medicationUuid;
        });
        medProfile.object.diseases = _.sortBy(medProfile.object.diseases, function (item) {
            return item.uuid;
        });
        return medProfile;
    },

    sortPermissions: function (perms) {
        //Backbone.Model({perms: perms})
        return _.sortBy(perms, function (perm) {
            return perm.id;
        })
    },

    mergedPermissionsCount: function (permissions, permission) {
        return (permissions || []).filter(function (p) {
            var pWoId = _.omit(_.omit(p, 'id'), 'permittedObjectId');
            var permissionWoId = _.omit(_.omit(permission, 'id'), 'permittedObjectId');
            return _.isEqual(pWoId, permissionWoId);
        });
    },

    hasPermissionsChanges: function() {
        var that = this;
        return (that.mergeToPersonPermissionsModelOriginal.attributes.perms || []).filter(function (item) {
            return that.mergedPermissionsCount(that.mergeToPersonPermissionsModel.attributes.perms, item).length == 0;
        }).length != 0
        || (that.mergeToPersonPermissionsModel.attributes.perms || []).filter(function (item) {
            return that.mergedPermissionsCount(that.mergeToPersonPermissionsModelOriginal.attributes.perms, item).length == 0;
        }).length != 0
    }

});

module.exports = MergePersonsDetailView;


//////////////////
// WEBPACK FOOTER
// ./app/views/persons/merge-persons-detail-view.js
// module id = 477
// module chunks = 0